import { Component, OnInit } from '@angular/core';
import { HandleLoadingState } from '../../../../../decorators/handle-loading-state.decorator';
import { getClaimKey } from '../../../../../functions/get-claim-key';
import { VocRehab } from '../../../../../models/api/view/claim/details/workers-compensation/voc-rehab';
import { BaseComponent } from '../../../../base/base.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { ExpandPanelComponent } from '../../../../core/panels/expand-panel.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TableComponent } from '../../../../core/table/table.component';
import { getExpandSubject } from '../../../../../functions/get-expand-subject';

@Component({
  selector: 'app-voc-rehab-wc',
  imports: [
    CardComponent,
    TableComponent,
    ColumnComponent,
    DetailPanelComponent,
    DetailItemComponent,
    AddressLabelComponent,
    ExpandPanelComponent,
  ],
  template: `
    <div class="tw-w-full tw-pt-4">
      <div class="tw-flex">
        <app-detail-panel
          [dataSource]="vocRehabData?.address"
          class="tw-basis-1/4 tw-pb-8"
        >
          <app-detail-item label="Name">
            <ng-template #value let-data>
              {{ data.name }}
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Address">
            <ng-template let-data #value>
              <app-address-label
                [street1]="data.address1"
                [street2]="data.address2"
                [city]="data.city"
                [postalCode]="data.zip"
                [state]="data.state"
              />
            </ng-template>
          </app-detail-item>
        </app-detail-panel>
      </div>

      <app-card label="VOC REHAB NOTES" ariaLabel="VOC rehab notes table">
        <app-table
          #vendorTable
          [dataSource]="vocRehabData?.notes || []"
          [pageSize]="10"
          recordLabel="voc rehab note"
          [showExport]="false"
          [expandable]="true"
          dataKey="noteID"
          sortField="created"
          [sortOrder]="-1"
          [error]="error"
          [loading]="loading"
        >
          <app-column name="created" label="Created" format="d" />
          <app-column name="createdBy" label="Created by" />
          <app-column name="createdFor" label="For" />

          <app-column name="text" [fullRow]="true" [fullRowLabel]="false">
            <ng-template #item let-row>
              <app-expand-panel
                [expanded]="vendorTable.expanded"
                [label]="
                  getExpandSubject(row.createdBy, row.created) ||
                  'Voc rehab note'
                "
                collapseHeight="114px"
              >
                <span
                  style="white-space: pre-line;"
                  [innerHTML]="row.text"
                ></span>
              </app-expand-panel>
            </ng-template>
          </app-column>
        </app-table>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class VocRehabWcComponent extends BaseComponent implements OnInit {
  vocRehabData: VocRehab;
  error: any = null;

  protected getExpandSubject = getExpandSubject;

  loading = true;

  @HandleLoadingState()
  async ngOnInit(): Promise<void> {
    this.vocRehabData = await this.api.vocRehab.getVocRehab(getClaimKey());
  }
}
